import React, { useMemo } from "react";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { Link, useParams, Redirect } from "react-router-dom";
import { Header, Segment, Grid } from "semantic-ui-react";
import { PublicWrapper } from "./PublicWrapper";
import { ConnectedLoginForm } from "./ConnectedLoginForm";
import identitySelectors from "../selectors/identity";
import { trackCitizenLogin } from "../mixpanel/login";

export const PublicLogin = (props: any) => {
  const { site } = useParams<{ site: string }>();
  const query = useMemo(() => queryString.parse(props.location.search), [props.location.search]);
  const isLoggedIn = useSelector(identitySelectors.isLoggedIn);
  const user = useSelector(identitySelectors.getUser);
  document.title = "Sign into your account";

  if (isLoggedIn) {
    trackCitizenLogin(user, site);
    return <Redirect to={(query.redirect as string) || `/${site}`} />;
  }

  return (
    <PublicWrapper homeUrl={`/${site}/public/permits`}>
      <Grid style={{ margin: 0, height: "100%" }} verticalAlign='middle' textAlign='center'>
        <Grid.Column style={{ maxWidth: "450px", textAlign: "left" }}>
          <Segment.Group>
            <Segment style={{ padding: 24 }}>
              <Header as='h1'>Sign In</Header>
              <ConnectedLoginForm site={site} usernameLabel='Email Address' allowRememberMe={true} />
            </Segment>
            <Segment attached='bottom' style={{ padding: 24, fontSize: 14 }} center textAlign='center'>
              {`New user? `}
              <Link
                style={{ fontWeight: "bold" }}
                to={`/${site}/public/register?redirect=${encodeURIComponent(query.redirect as string)}`}
              >
                Create an account
              </Link>
            </Segment>
          </Segment.Group>
        </Grid.Column>
      </Grid>
    </PublicWrapper>
  );
};
